'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var flexPositions = exports.flexPositions = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};

var colors = exports.colors = {
  blue: 'blue',
  red: 'red',
  green: 'green'
};

var positions = exports.positions = {
  static: 'static',
  relative: 'relative',
  absolute: 'absolute',
  fixed: 'fixed',
  sticky: 'sticky'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Modal/ModalConstants.js
// module id = 1212
// module chunks = 0